<template>
  <div class="full-body-content align-items-center">
    <b-row class="v-full justify-content-center">
      <b-col md="6" align-self="center">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">500</h1>
          <h4 class="pt-3">Houston, we have a problem!</h4>
          <p class="text-muted">The page you are looking for is temporarily unavailable.</p>
        </div>
          
        <b-img :src="$config.getAssetsURL('img/brand/AgriOpenMouth.png')" width="60" fluid alt="" />
        <b-button block variant="success" class="btn-home" :to="{ name:'Home' }">Let's Go Home !</b-button>

      </b-col>
    </b-row>
  </div>


</template>

<script>
export default {
  name: 'Page500',
  mounted ()
  {
    // 檢查 token 不存在，就導向 Login
    if ( !localStorage.token )
    {
      // this.$router.push({ name: 'Login' });
    }
    else
    {
      // 檢查 token 是否有效
      this.$store.dispatch('user/refreshToken')
        .then(() => {
        })
        .catch( err => {
          // console.log( 'refresh token err' );
          // console.log( err );
          
          // 清除資料
          this.$store.commit('user/cleanData');
          // 清空 token
          localStorage.removeItem('token');
          // 沒有拿到新的 token 就導向 Login
          this.$router.push({ name: 'Login' });
        })
    }
  },
}
</script>
